import type { RouteRecordRaw } from "vue-router";
import { beforeEnterFeatureFlagged } from "./middleware/beforeEnterFeatureFlagged";

export const contentRoutes: RouteRecordRaw[] = [
  {
    name: RouteNames.CONTENT_LIST,
    path: "",
    component: () => import("../views/content/ContentListView.vue"),
    meta: {
      titleTag: "Content | Marketing Assistant",
    },
  },
  {
    path: "calendar",
    children: [
      {
        path: "new",
        name: RouteNames.NEW_CALENDAR_CONTENT,
        beforeEnter: isDESKTOP ? undefined : beforeEnterFeatureFlagged("contentCalendar"),
        component: () => import("@/views/content/NewCalendarContentView.vue"),
      },
      {
        path: ":id",
        name: RouteNames.EDIT_CALENDAR_CONTENT,
        beforeEnter: isDESKTOP ? undefined : beforeEnterFeatureFlagged("contentCalendar"),
        component: () => import("@/views/content/EditCalendarContentView.vue"),
      },
      {
        path: "",
        name: RouteNames.CONTENT_CALENDAR,
        beforeEnter: isDESKTOP ? undefined : beforeEnterFeatureFlagged("contentCalendar"),
        component: () => import("@/views/content/ContentCalendarView.vue"),
        meta: {
          titleTag: "Content Calendar | Marketing Assistant",
        },
      },
    ],
  },
  {
    path: "saved",
    name: RouteNames.SAVED_CONTENT_LIST,
    component: () => import("@/views/content/SavedContentListView.vue"),
    meta: {
      titleTag: "Saved Content | Marketing Assistant",
    },
  },
  {
    path: ":id",
    name: RouteNames.SINGLE_CONTENT,
    component: () => import("@/views/content/SingleContentView.vue"),
    meta: {
      titleTag: "Content | Marketing Assistant",
    },
  },
];
